import { Injectable, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import { bytesFormatter } from '../byte/bytes.pipe';
import { FilesValidator, NotificationMetadata } from '../file.model';
import { ReadFile } from '../read-file.model';
import { ApFileSelectorComponent } from '../selector/selector.component';

@Injectable()
export class ApSizeValidator implements FilesValidator {
    private readonly contentService = inject(ApContentService);

    public fileSelector: ApFileSelectorComponent;

    public showNotification = false;
    public multipleAdded = false;

    public getNotification(): NotificationMetadata {
        const key = this.multipleAdded ? 'file.selector.warning.fileSize.multiple' : 'file.selector.warning.fileSize';
        const sizeLimit = bytesFormatter.transform(this.fileSelector.fileSizeLimitInMB() * 1024 * 1024);
        return {
            type: 'error',
            testId: 'fileSizeError',
            content: this.contentService.get(key, { sizeLimit })
        };
    }

    public validate(previousValue: ReadFile[], currentValue: ReadFile[]): boolean {
        let isValid = true;
        currentValue.forEach((file) => {
            if (file.size > this.fileSelector.fileSizeLimitInMB() * 1024 * 1024) {
                isValid = false;
            }
        });
        this.showNotification = !isValid;
        this.multipleAdded = currentValue.length - previousValue.length > 1;
        return isValid;
    }
}
